<template>
  <v-row>
    <v-col>
      <h1 class="text-h3">
        {{ t('home.welcomeMessage') }}
      </h1>
      <p class="text-secondary-darken-1 mt-4">
        {{ t('home.welcomeMessageDescription') }}
      </p>
    </v-col>
  </v-row>
  <v-row class="mt-10">
    <v-col v-for="link in externalLinks" :key="link.title" class="col--hover">
      <SectionLink
        :title="link.title"
        :description="link.description"
        :icon="link.icon"
        :link="link.link"
        :color="link.color"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col class="pb-0">
      <p class="text-body-2">{{ t('home.nextSteps') }}</p>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="link in internalLinks" :key="link.title" class="col--hover" cols="4">
      <SectionLink
        :title="link.title"
        :description="link.description"
        :icon="link.icon"
        :link="link.link"
        :color="link.color"
      />
    </v-col>
  </v-row>
  <v-divider :thickness="2" class="my-8"></v-divider>
  <v-row class="mt-10">
    <v-col>
      <h2 class="text-h5">{{ t('common.applications') }}</h2>
    </v-col>
    <v-col class="text-right">
      <v-btn variant="text" color="primary">{{ t('common.viewAllButton') }}</v-btn>
    </v-col>
  </v-row>
  <AppList />
  <v-row v-if="canReadDashboards" class="mt-10">
    <v-col>
      <h2 class="text-h5">{{ t('common.dashboards') }}</h2>
    </v-col>
    <v-col class="text-right">
      <v-btn variant="text" color="primary">{{ t('common.viewAllButton') }}</v-btn>
    </v-col>
  </v-row>
  <v-row v-if="canReadDashboards">
    <v-col v-for="dashboard in dashboards" :key="dashboard.id">
      <DashboardCard
        :title="dashboard.title"
        :description="dashboard.description"
        :icon="dashboard.icon"
        :link="dashboard.link"
        :color="dashboard.color"
        :type="dashboard.type"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import AppList from '@/components/AppList.vue'
import DashboardCard from '@/components/DashboardCard.vue'
import SectionLink from '@/components/SectionLink.vue'
import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const daisuke = daisukeAuth0Store()
const canReadDashboards = daisuke.hasPermission('read:dashboards')

// @ts-expect-error TODO: define
const externalLinks = [
  //{
  //  title: "Knowledge Base",
  //  description: "Need to know how to use a specific tool or workflow?",
  //  icon: "mdi-book-open-variant",
  //  link: "/knowledge-base",
  //  color: "secondary",
  //},
  //{
  //  title: "Technosylva Campus",
  //  description: "Use case and workflow training.",
  //  icon: "mdi-school",
  //  link: "",
  //  color: "secondary",
  //},
  //{
  //  title: "Support Desk",
  //  description: "Provide feedback, report a bug or request a feature.",
  //  icon: "mdi-help-circle",
  //  link: "",
  //  color: "secondary",
  //},
]

const internalLinks = [
  //{
  //  title: 'Getting Started',
  //  description: 'Learn about your platform and tools.',
  //  icon: 'mdi-directions',
  //  link: '#',
  //  color: 'primary'
  //},
  {
    title: 'Invite Users',
    description: 'Add additional users from your organization.',
    icon: 'mdi-account-plus',
    link: '/users',
    color: 'primary',
    permission: 'create:invitations',
  },
  {
    title: 'Upload Asset Data',
    description: 'Upload your asset data to be processed.',
    icon: 'mdi-database-plus',
    link: '/dataupload',
    color: 'primary',
    permission: 'read:uploads',
  },
].filter((link) => (link.permission ? daisuke.hasPermission(link.permission) : true))

const dashboards = [
  {
    id: 1,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
  {
    id: 2,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
  {
    id: 3,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
]
</script>
